import { Component, OnInit } from '@angular/core';
import {FormGroup} from '@angular/forms';

@Component({
  selector: 'acabim-admin-add-asset-type-classification',
  templateUrl: './add-asset-type-classification.component.html',
  styleUrls: ['./add-asset-type-classification.component.scss']
})
export class AddAssetTypeClassificationComponent implements OnInit {

  public loading = false;
  public assetTypeClassificationForm: FormGroup | null = null;

  constructor() { }

  ngOnInit(): void {
  }


  onSubmit(): void {}
  onCancel(): void {}
  onGo(next: number): void {}
}
